import CustomButtton from "../Button/CustomButtton";
import { footerbottombg, group, herohello } from "../../images/general";
import React, { useState } from "react";
import { subsribeForNewsletter } from "../../services/mongoApiService";
import { useUiState } from "../../context/UiContext";
import { ToastType } from "../../types/UI";
import { isValidEmail } from "../../utils";

const HomeFooter = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const {
    actions: { showToast },
  } = useUiState();

  const addToNewsletter = async () => {
    setIsLoading(true);
    try {
      const response = await subsribeForNewsletter(email);
      if(response?.success) {
        showToast({ type: ToastType.SUCCESS, msg: "Successfully subscribed !" });
      }
      setEmail("");
    }
    catch(error) {
      console.log("Error while subscribing for newsletter", error);
    }
    setIsLoading(false);
  }

  return (
    <>
      <section
        style={{ backgroundImage: `url(${footerbottombg})` }}
        className="w-full bg-no-repeat bg-cover h-full py-1 bg-center"
      >
        <div className="container max-w-7xl mx-auto px-4 sm:py-20 sm:pb-20 py-5 pb-0">
          <div className="lg:flex sm:flex-row flex-col-reverse flex">
            <div className="lg:w-1/5" 
                        data-sal="slide-right"
                        data-sal-delay="400"
                        data-sal-easing="ease">
              <div className="relative">
                <img
                  src={herohello}
                  className="sm:absolute sm:-bottom-[148px] sm:left-0 mx-auto sm:w-max sm:h-max w-[140px] h-[210px] hover:scale-x-110 transition duration-300"
                  alt=""
                />
              </div>
            </div>
            <div className="lg:w-4/5 mt-6 lg:mt-0"             
            data-sal="fade-in"
              data-sal-delay="400"
              data-sal-easing="ease">
              <div className="lg:flex">
                <div>
                  <h2 className="sm:text-left text-center sm:text-[32px] text-lg font-cinzel text-white uppercase font-bold sm:leading-[32px] leading-[18px] sm:max-w-4xl sm:w-full w-4/5 sm:mx-0 mx-auto sm:mb-0 mb-6">
                    <span className="text-[#ACD6E9]">Sign up</span> for our
                    exclusive email updates
                  </h2>
                </div>
                <div>
                  <div className="sm:flex gap-5">
                    <input
                      type="text"
                      id="text-input"
                      value={email}
                      name="text-input"
                      className="sm:mb-0 mb-3 block lg:px-4 lg:py-4 sm:px-2 sm:py-2 px-2 py-2 border bg-[#212428] rounded-lg border-[#AECDE5] outline-none text-white placeholder:text-[#B1BDC8] shadow-sm sm:text-sm sm:w-[347px] w-full"
                      placeholder="Enter your e-mail address"
                      onChange={(ev) => setEmail(ev.target.value)}
                      disabled={isLoading}
                    />
                    <CustomButtton text="Subscribe" onClick={addToNewsletter} icon2={group} isLoading={isLoading} disabled={!isValidEmail(email) || isLoading}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeFooter;
